import { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminCMSList from "@/pages/admin/AdminCMSList";
import { api } from "@/lib/apiClient";

const CATEGORIES = [
  { value: "packaging", label: "Packaging" },
  { value: "delivery", label: "Delivery" },
  { value: "sustainability", label: "Sustainability" },
  { value: "marketing", label: "Marketing" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "business", label: "Business" },
  { value: "technology", label: "Technology" },
  { value: "ideas", label: "Ideas" },
];

function SolutionsViewer() {
  const [sols, setSols] = useState([]);
  useEffect(() => { api.get("/admin/challenge-solutions").then((r) => setSols(r.data || [])); }, []);
  const setStatus = async (id, status) => { await api.put(`/admin/challenge-solutions/${id}/status`, { status }); toast.success(`Set ${status}`); api.get("/admin/challenge-solutions").then((r) => setSols(r.data || [])); };

  if (sols.length === 0) return null;
  return (
    <div className="mt-12">
      <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Submitted Solutions</div>
      <div className="mt-4 card-elevated overflow-x-auto">
        <table className="w-full text-sm" data-testid="sol-table">
          <thead className="text-left text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">
            <tr className="border-b border-brand-line"><th className="p-4">Challenge</th><th className="p-4">By</th><th className="p-4">Headline</th><th className="p-4">Status</th><th className="p-4">When</th></tr>
          </thead>
          <tbody>
            {sols.map((s) => (
              <tr key={s.id} className="border-b border-brand-line last:border-0">
                <td className="p-4">{s.challenge_title}</td>
                <td className="p-4"><div>{s.name}</div><div className="text-xs text-brand-charcoal/55">{s.phone} {s.email}</div></td>
                <td className="p-4 max-w-md"><div className="font-medium">{s.headline || "—"}</div><div className="text-xs text-brand-charcoal/65 line-clamp-2 mt-1">{s.solution}</div></td>
                <td className="p-4">
                  <select className="text-xs border border-brand-line rounded-full px-2 py-1 bg-white" value={s.status || "new"} onChange={(e) => setStatus(s.id, e.target.value)}>
                    {["new","reviewing","accepted","rejected"].map((x) => <option key={x} value={x}>{x}</option>)}
                  </select>
                </td>
                <td className="p-4 text-xs text-brand-charcoal/55">{(s.created_at || "").slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function AdminChallenges() {
  return (
    <div>
      <AdminCMSList
        testIdPrefix="admin-challenges" title="Challenge" subtitle="Innovation Challenges"
        listEndpoint="/admin/challenges"
        createEndpoint="/admin/challenges"
        updateEndpoint={(id) => `/admin/challenges/${id}`}
        deleteEndpoint={(id) => `/admin/challenges/${id}`}
        blank={{ title: "", category: "ideas", brief: "", reward: "", deadline: "", image_url: "", status: "open", is_visible: true }}
        fields={[
          { key: "title", label: "Title", full: true },
          { key: "category", label: "Category", type: "select", options: CATEGORIES },
          { key: "status", label: "Status", type: "select", options: [{value:"open",label:"Open"},{value:"closed",label:"Closed"}] },
          { key: "brief", label: "Brief", type: "textarea", full: true, rows: 4 },
          { key: "reward", label: "Reward" },
          { key: "deadline", label: "Deadline" },
          { key: "image_url", label: "Image URL", full: true },
          { key: "is_visible", label: "Visible on site", type: "checkbox" },
        ]}
        renderCard={(c) => (
          <div className="p-5">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brand-red">{c.category}</div>
            <div className="font-display text-xl mt-1">{c.title}</div>
            <p className="text-xs text-brand-charcoal/70 mt-2 line-clamp-2">{c.brief}</p>
            <div className="mt-2 text-[10px] text-brand-charcoal/60">{c.status} {c.reward && `· ${c.reward}`}</div>
          </div>
        )}
      />
      <SolutionsViewer />
    </div>
  );
}
